import React from 'react'
import FaIcon from '../../../common/FaIcon/FaIcon'
import { getYearsOfExperience } from '../../../../utils/experience'

import './Hero.scss'

const Hero = () => {
  // eslint-disable-next-line react/prop-types
  const HeroTags = ({ block, bullet }) => {
    const tags = [
      `${getYearsOfExperience()}+ years experience`,
      'UX leadership',
      'Design systems',
      'Frontend development',
    ]

    return (
      <div className={`hero-tags ${block ? 'block' : bullet ? 'bullet' : ''}`}>
        {tags.map((tag) => {
          return (
            <div className='hero-tag-group' key={tag}>
              <span className='hero-tag child'>{tag}</span>
              {bullet && <FaIcon name='circle-small' size={8} />}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className='hero'>
      <div className='hero-text-container'>
        <h1 className='display'>
          I&apos;m Jason, a lead UX designer &amp; manager who creates
          interfaces with a focus on accessibility and usability
          {/* I design interfaces and systems with a focus on accessibility and
          usability. */}
        </h1>
        <div className='hero-tag-container'>
          <HeroTags block />
        </div>
      </div>
    </div>
  )
}

export default Hero
